import React from 'react';

import AnalyticsTooltip from '../../components/analytics-tooltip';
import { Icon } from 'semantic-ui-react';

import { YOUTUBE, FACEBOOK, INSTAGRAM, TWITTER, SNAPCHAT } from '../../utils/static-configuration';
import ResourceDelete from '../../containers/resource-delete';
import Removable from '../../components/removable';
import { scientificFormat, formatNumberWithPercentage } from '../../utils/helpers/formatting';

const YOUTUBE_COMPLIANT = false;

const renderText = text => { return (<p>{text}</p>); };
const renderTooltip = (description, main, percentage) => {
  return (
    <AnalyticsTooltip content={description} style="analytics-small-frame">
      <p className="small">{main}</p>
      { YOUTUBE_COMPLIANT && <p className="small light">{percentage}</p>}
    </AnalyticsTooltip>
  );
};

const AssetListContent = ({ data, viewVideo, openEngagementScoreModal, filterBy }) => {
  if (!data) return null;

  const title = data.get('title');
  const id = data.get('id');
  const type = data.get('type') || 'trackedAssets';
  const assetId = data.get('assetId');
  const thumbnail = data.get('thumbnail');
  const influencerName = data.get('influencerName');
  const engagementScore = data.get('engagementScore');
  const likes = data.get('likes');
  const reactions = data.get('reactions') || 0;
  const shares = data.get('shares') || 0;
  const reach = data.get('reach') || 0;
  const dislikes = data.get('dislikes') || null;
  const comments = data.get('comments') || 0;
  const followers = data.get('followers') || 0;
  const views = data.get('views');
  const campaignName = data.getIn(['campaign', 'name']);
  const discussionName = data.getIn(['discussion', 'name']);
  const channelTitle = data.get('channelTitle');
  const publishedDate = data.get('publishedDate');
  const isUserAsset = data.get('campaign') ? false : true;
  const platform = data.get('platform');
  const assetType = data.get('assetType');
  const isVideo = data.get('isVideo');
  const retweets = data.get('retweets');
  const addExtraInfo = (platform === FACEBOOK || platform === INSTAGRAM) ? true : false;
  const extraTitleInfo = isVideo ? ' (video)' : ' (image)';

  const facebookContent = {
    first: renderText(scientificFormat(shares)), // shares
    second: renderText(scientificFormat(likes)),
    third: renderText(scientificFormat(reactions)),
    fourth: renderText(scientificFormat(comments)),
    fifth: renderText(scientificFormat(views)),
  };

  const twitterContent = {
    first: renderText(scientificFormat(retweets)),
    second: renderText(scientificFormat(likes)),
    third: renderText('-'),
    fourth: renderText(scientificFormat(reach)),
    fifth: renderText('-'),
  };

  const instagramContent = {
    first: renderTooltip('Number of likes as a percentage of followers.', scientificFormat(likes), formatNumberWithPercentage(likes, followers)),
    second: renderTooltip('Number of comments as a percentage of followers.', scientificFormat(comments), formatNumberWithPercentage(comments, followers)),
    third: renderText(scientificFormat(followers)),
    fourth: isVideo ? renderText(scientificFormat(views)) : renderText('N/A'),
    fifth: renderText(engagementScore),
  };

  const youtubeContent = {
    first: renderTooltip('Number of likes as a percentage of views.', scientificFormat(likes), formatNumberWithPercentage(likes, views)),
    second: renderTooltip('Number of dislikes as a percentage of views.', scientificFormat(dislikes), formatNumberWithPercentage(dislikes, views)),
    third: renderTooltip('Number of comments as a percentage of views.', scientificFormat(comments), formatNumberWithPercentage(comments, views)),
    fourth: renderText(scientificFormat(views)),
    fifth: renderText('-'),
    fifthReal: renderText(engagementScore),
  };

  const contentOptions = {
    FACEBOOK: facebookContent,
    INSTAGRAM: instagramContent,
    YOUTUBE: youtubeContent,
    TWITTER: twitterContent,
  };

  const localStyles = {
    textAlign: 'center'
  }

  return (
    <Removable>
      <div className="asset-card">
        <div className="flex-item">
        { thumbnail &&
          <img onClick={viewVideo} className="thumbnail" src={thumbnail} alt={title} />
        }

        { !thumbnail &&
          <p style={localStyles}>
            <Icon name="twitter" color="grey" size="large" />
          </p>
        }
        </div>
        <div className="flex-spacer">
          { channelTitle && <p className="small">{channelTitle}</p> }
          <p className="small"><a onClick={viewVideo}>{ title.slice(0, 50).trim() }{ title.length > 50 ? '...' : '' }{ addExtraInfo ? extraTitleInfo : '' }</a></p>
          { filterBy !== 'myVideos' && campaignName && discussionName && <p className="tiny">{campaignName} &#160;&#62;&#160; {discussionName}</p> }
        </div>
        <div className="flex-item stat">
          { contentOptions[platform].first }
        </div>
        <div className="flex-item stat">
          { contentOptions[platform].second }
        </div>
        <div className="flex-item stat">
          { contentOptions[platform].third }
        </div>
        <div className="flex-item stat">
          { contentOptions[platform].fourth }
        </div>
        <div className="flex-item stat">
          { contentOptions[platform].fifth }
        </div>
        <div className="flex-item-small actionX">
          <ResourceDelete resourceId={id} resourceType={type} visible={isUserAsset} />
        </div>
      </div>
    </Removable>
  );
};

AssetListContent.propTypes = {
  openEngagementScoreModal: React.PropTypes.func.isRequired,
};

export default AssetListContent;



/** WEBPACK FOOTER **
 ** ./src/components/analytics-asset-list-content/index.js
 **/